"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.getTmcLink = getTmcLink;
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _constants = require("../constants");
var _auth = require("./auth/");
var _AuAnalytics = _interopRequireDefault(require("./AuAnalytics"));
/***** ONLY USED IN CONSOLE and DEV PORTAL ****/

// TODO: handle localhost return <Links> or false for everything

function getTmcLink(linkType, baseDomain, partition = {}, docAccess = _auth.clientContainer?.client?.docAccess, host = location.host) {
  var _context;
  const onClick = () => _AuAnalytics.default.trackEvent({
    category: 'GlobalNav',
    action: 'TmcLinks',
    label: linkType
  });
  switch (linkType) {
    case _constants.DEV_PORTAL_LINK:
      return {
        displayId: 'au.devPortal',
        destination: 'https://' + host.replace('console', 'developer') + '/',
        onClick
      };
    case _constants.CONSOLE_LINK:
      if (docAccess === 'partners') {
        return false;
      }
      return {
        displayId: 'au.console',
        destination: 'https://' + host.replace('developer', 'console') + '/',
        onClick
      };
    case _constants.FEEDBACK_LINK:
      if ((0, _includes.default)(_context = ['autonomic', 'account-1', 'ford']).call(_context, docAccess)) {
        return {
          displayId: 'au.feedback',
          destination: 'https://forms.gle/uqRXG7q6a91T8o4D8',
          onClick
        };
      } else {
        return false; // for partners
      }

    case _constants.HELP_LINK:
      return {
        displayId: 'au.helpCenter',
        destination: 'https://ford.atlassian.net/servicedesk/customer/portal/1131/group/1298',
        onClick
      };
    case _constants.INSIGHTS_LINK:
      if (partition === 'na') {
        var _context2;
        if ((0, _includes.default)(_context2 = ['autonomic', 'account-1', 'ford']).call(_context2, docAccess)) {
          return {
            displayId: 'au.insights',
            destination: 'https://insights.' + baseDomain,
            onClick
          };
        } else if (docAccess === 'partners') {
          return false;
        }
      }
      return {
        displayId: 'au.insights',
        destination: 'https://insights.' + baseDomain,
        onClick
      };
    case _constants.TMC_METRICS_LINK:
      if (partition === 'na') {
        var _context3;
        if ((0, _includes.default)(_context3 = ['autonomic', 'account-1', 'ford']).call(_context3, docAccess)) {
          return {
            displayId: 'au.tmcMetrics',
            destination: 'https://grafana.au-infrastructure.com',
            onClick
          };
        } else if (docAccess === 'partners') {
          return false;
        }
      }
      if (partition === 'cnp0' || partition === 'cnp0a1' || partition === 'cnp1' || partition === 'cnp1a1' || partition === 'cns') {
        return {
          displayId: 'au.tmcMetrics',
          destination: 'https://grafana.tools.tmc79.cn',
          onClick
        };
      }
      return {
        displayId: 'au.tmcMetrics',
        destination: 'https://grafana.au-infrastructure.com',
        onClick
      };
    case _constants.STATUS_PAGE_LINK:
      return {
        displayId: 'au.serviceStatus',
        destination: 'https://status.autonomic.com/',
        onClick
      };
  }
}